/**
 * @file Entrypoint for surface page.
 */

import { setupSurfaceVueApp } from '@@/bits/surface_page'
import Surface from '@@/vuecomponents/Surface.vue'

setupSurfaceVueApp(Surface)
